import { ReportingShellControllerBaseConfig } from '../../../base';
import { ThreadListController } from './threadListInterface';
import { ThreadListViewProps } from './threadListProps';

export function createThreadListController(
    config: ReportingShellControllerBaseConfig
): ThreadListController {
    return {
        useProps(context, item, props): ThreadListViewProps {
            return {
                items: item.items.map((item) => ({
                    id: item.integration.id,
                    item,
                })),
            };
        },
    };
}
